import React, { useState, useEffect } from 'react';
import QuestionStep from './QuestionStep';
import logo from 'assets/img/BoHouse.png';
import logoIcon from 'assets/img/logoIcon.png';
import { useParams } from 'react-router-dom';
import firebase from '../../../firebase';
const CryptoJS = require('crypto-js');
import './question.css'

function encryptCardData(cardData, secretKey) {
  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(cardData), secretKey).toString();
  return encrypted;
}

const MultiStepForm = ({ questions = [], review= false }) => {
  const [currentStep, setCurrentStep] = useState(0);

  const { reservationId } = useParams();

  const [answers, setAnswers] = useState({});


  const handleAnswer = (step, answer) => {
    setAnswers((prev) => ({
      ...prev,
      [step]: answer,
    }));
    setCurrentStep((prev) => prev + 1); // Passe à l'étape suivante

  };

  // Add useEffect to handle browser back button
  useEffect(() => {
    const handleBackButton = (e) => {
      e.preventDefault();
      if (currentStep > 0) {
        setCurrentStep(prev => prev - 1);
        // Les réponses sont déjà conservées dans l'état 'answers'
        // donc pas besoin de les réinitialiser car elles persistent
      }
    };

    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener('popstate', handleBackButton);

    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, [currentStep]);


  useEffect(() => { 
    if (questions[currentStep] && questions[currentStep].dependentOn && answers[currentStep - 1] === "Non / No") { 
      if (questions[currentStep].dependentOn === "radioyes"){
        let t = questions[currentStep].check; 
        if (answers[t.value].includes(t.label)){
          console.log('Dépendance trouvée et positive, on reste');
          return;
        } 
      }
      console.log('Dépendance trouvée mais negatif');
      setCurrentStep((prev) => prev + 1);
    } 
    if (questions[currentStep].type === "send") {
      console.log('Fin du formulaire');
      // console.log('answers', answers)
      handleSubmit()

    }

  }, [currentStep])


  // Fonction pour gérer les allergies

  function associateAnswers(questions, awser, secretKey) {
    return questions.map((question, index) => {
      let answer;

      if (question.type === 'checkbox' || question.type === 'radio' || question.type === 'radioyes' || question.type === 'radiono') {
        // Si c'est une question à choix (checkbox ou radio), on récupère la réponse de awser en fonction de l'indice
        answer = awser[index.toString()] || [];
      } else if (question.type === 'text' || question.type === 'textarea') {
        // Pour les réponses textuelles, on récupère directement la valeur de awser
        answer = awser[index.toString()] || "";
      } else if (question.type === 'card') {
        // Pour la carte, on récupère les sous-champs de awser[10]
        const encryptedCardData = encryptCardData(awser[index.toString()], secretKey);
        // const decryptedCardData = decryptCardData(encryptedCardData, 'secretKey');
        // console.log("Données décryptées :", decryptedCardData);
        answer = encryptedCardData || {};
      } else {
        // Pour d'autres types, on retourne null si aucune réponse n'existe
        answer = null;
      }

      return {
        question: question.french,
        answer
      };
    });
  }


  // Liste des questions à afficher, avec version en français et en anglais

  // Fonction de soumission du formulaire
  const handleSubmit = () => { 
    //e.preventDefault();
    const result = associateAnswers(questions, answers, reservationId);
    // console.log("Réponses soumises : ", result);
    
    firebase.firestore().collection('questions').add({ result: result, reservationId: reservationId, _createAt: new Date() });
    // Vous pouvez envoyer ces données à un serveur ou traiter les réponses
  };
  function isMobile() {
    return window.innerWidth <= 768; // Vous pouvez ajuster la largeur selon vos besoins
  }

  const canCheck = () => {  
    let can = true;
    questions.forEach((q, i) =>{
      if (q.type === "ratings" && answers[i]) {
        if (Number(answers[i]) < 4) { 
          can =  false;
        }
      }
    })
    return can;
  }

  return (
    <div

      style={!isMobile() ? {
        position: "relative",
        width: "80%",
        height: "100vh",/* Hauteur de la vue complète */
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: currentStep === questions.length - 1 && canCheck() && 'column'
      } : {
        position: "relative",
        width: "100%",
        height: "100vh",
      }}
    >
      <img style={{
        top: 30,
        left: "50%",
        transform: "translateX(-50%)",
        width: 50, position: isMobile() ? "relative" : "absolute"
      }} src={logoIcon} alt="Logo" />

      <form onSubmit={handleSubmit} className=" questions form-container">
        {questions.map((question, index) =>
          currentStep === index ? (
            <QuestionStep
              key={index}
              islast={currentStep === questions.length - 1}
              step={index}
              question={question}
              answers={answers}
              onAnswer={handleAnswer}
            />
          ) : null
        )}
      </form>
      {currentStep === questions.length - 1 && canCheck() && review && (
        <div style={{ flexDirection: 'column', display: "flex", textAlign: "center" }}>
          <button 
            style={{
            borderRadius: 5,
            backgroundColor:'#E55736',
            color: '#DECFC8',
            marginBottom:20,
            fontFamily: "'Louize', sans-serif",
            }}
          onClick={() => {
            // Open a new tab
            const newTab = window.open('https://g.page/r/CdfW4_gXrhFjEBM/review', '_blank');

            // Focus on the new tab
            newTab.focus();
          }}
        >
          {'Déposer un avis sur google'.toUpperCase()}
        </button>
          <span style={{color: 'white',
            fontFamily: "'Louize', sans-serif",}} onClick={() => {
            // Open a new tab
            const newTab = window.open('https://g.page/r/CdfW4_gXrhFjEBM/review', '_blank');

            // Focus on the new tab
            newTab.focus();
          }}>Leave a review on Google</span>
          </div>
      )} 
      <img
        style={{
          padding: 20,
          bottom: !isMobile() ? 30 : 0,
          left: "50%",
          zIndex: 20,
          transform: "translateX(-50%)", position: isMobile() ? "relative" : "absolute",
          width: 150
        }}

        src={logo} alt="Logo" />
 
    </div>
  );
};
export default MultiStepForm;